import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Filter, Sliders } from 'feather-icons-react/build/IconComponents';
import { actions as changeRequestActions } from './store/slice';
import { selectChangeRequestFilterVisible } from './store/selectors';

const { setFilterVisible, setSearchText } = changeRequestActions;

const ChangeRequestSearch = () => {
  const dispatch = useDispatch();
  const filterVisible = useSelector(selectChangeRequestFilterVisible);
  const [searchText, setSearchTextValue] = useState('');

  const handleSearch = e => {
    const value = e.target.value;
    setSearchTextValue(value);
    dispatch(setSearchText(value));
  };

  const toggleFilter = () => {
    dispatch(setFilterVisible(!filterVisible));
  };

  return (
    <>
      <div className="search-set">
        <div className="search-input">
          <Link to="#" className="btn btn-searchset">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-search"
            >
              <circle cx={11} cy={11} r={8} />
              <line x1={21} y1={21} x2="16.65" y2="16.65" />
            </svg>
          </Link>
          <div id="DataTables_Table_CR_filter" className="dataTables_filter">
            <label>
              <input
                type="search"
                className="form-control form-control-sm"
                placeholder="Search Change Requests"
                value={searchText}
                onChange={handleSearch}
              />
            </label>
          </div>
        </div>
      </div>
      <div className="search-path">
        <Link
          className={`btn btn-filter ${filterVisible ? 'setclose' : ''}`}
          id="cr_filter_search"
          onClick={toggleFilter}
        >
          <Filter className="filter-icon" />
        </Link>
      </div>
    </>
  );
};

export default ChangeRequestSearch;
